import PropTypes from 'prop-types'
import { useEffect, useRef, useState } from 'react'
import { Dropdown, positionDropdown } from '../../../../common/dropdown'
import { HandleClickOutside } from '../../../../common/HandleClickOutside'
import { Element } from '../../../../common/html/element'
import { ScrollComponent } from '../../../../common/scrollComponent'
import { getInnerHeight } from '../../../../helpers/device'
import { SCROLL_LAYOUT_ELEMENT_ID } from '../../../../layout/LayoutContainer'

export const CustomDropdown = ({
  renderElement,
  renderDropdown,
  isToggleOnClick,
  isDropdownFollowWidth,
  onToggleShowDropdown,
  allowShowDropdown,
  wrapperClassname,
  dropdownItemHeight,
  maxDropdownItem,
  dropdownClassName,
  dropdownStyle,
  dropdownPosition,
}) => {
  const [isShowDropdown, setIsShowDropdown] = useState(false)

  const elementRef = useRef()

  const showDropdown = () => {
    setIsShowDropdown(true)
  }

  const hideDropdown = () => {
    setIsShowDropdown(false)
  }

  const toggleShowDropdown = () => {
    setIsShowDropdown((prev) => !prev)
  }

  useEffect(() => {
    onToggleShowDropdown && onToggleShowDropdown(isShowDropdown)
  }, [isShowDropdown])

  const dropdownHeight = dropdownItemHeight
    ? maxDropdownItem * dropdownItemHeight
    : null

  const position =
    dropdownPosition || dropdownHeight
      ? getInnerHeight() - elementRef.current?.getBoundingClientRect()?.bottom <
        dropdownHeight
        ? positionDropdown.TOP_START_RIGHT
        : positionDropdown.BOTTOM_START_RIGHT
      : positionDropdown.BOTTOM_START_RIGHT

  useEffect(() => {
    const hideDropdown = () => setIsShowDropdown(false)

    const scrollElementIds = ['MainContent', SCROLL_LAYOUT_ELEMENT_ID]
    const scrollElements = scrollElementIds.map((id) =>
      document.querySelector(`#${id} .scrollbars div:first-child`),
    )

    window.addEventListener('resize', hideDropdown)
    scrollElements.forEach((element) => {
      if (element) element.addEventListener('scroll', hideDropdown)
    })

    return () => {
      window.removeEventListener('resize', hideDropdown)
      scrollElements.forEach((element) => {
        if (element) element.removeEventListener('scroll', hideDropdown)
      })
    }
  }, [])

  return (
    <>
      <Element
        ref={elementRef}
        className={wrapperClassname}
        onClick={isToggleOnClick ? toggleShowDropdown : showDropdown}
      >
        {renderElement({ isShowDropdown, showDropdown, hideDropdown })}
      </Element>
      {allowShowDropdown && isShowDropdown && (
        <Dropdown parentRef={elementRef} position={position}>
          <HandleClickOutside
            handleClickOutside={hideDropdown}
            exceptRef={elementRef}
          >
            <Element
              className={dropdownClassName}
              style={{
                backgroundColor: '#FFFFFF',
                borderRadius: 4,
                padding: '8px 0px',
                overflow: 'hidden',
                width: isDropdownFollowWidth
                  ? elementRef.current.offsetWidth
                  : undefined,
                minWidth: !isDropdownFollowWidth
                  ? elementRef.current.offsetWidth
                  : undefined,
                maxWidth: !isDropdownFollowWidth ? 600 : undefined,
                height: dropdownHeight,
                ...dropdownStyle,
              }}
            >
              {dropdownHeight ? (
                <ScrollComponent>
                  {renderDropdown({ hideDropdown, position })}
                </ScrollComponent>
              ) : (
                renderDropdown({ hideDropdown, position })
              )}
            </Element>
          </HandleClickOutside>
        </Dropdown>
      )}
    </>
  )
}

CustomDropdown.propTypes = {
  renderElement: PropTypes.func.isRequired,
  renderDropdown: PropTypes.func.isRequired,
  isToggleOnClick: PropTypes.bool,
  isDropdownFollowWidth: PropTypes.bool,
  onToggleShowDropdown: PropTypes.func,
  allowShowDropdown: PropTypes.bool,
  wrapperClassname: PropTypes.string,
  dropdownItemHeight: PropTypes.number,
  maxDropdownItem: PropTypes.number,
  dropdownClassName: PropTypes.string,
  dropdownStyle: PropTypes.object,
  dropdownPosition: PropTypes.string,
}

CustomDropdown.defaultProps = {
  renderElement: () => null,
  renderDropdown: () => null,
  isToggleOnClick: false,
  isDropdownFollowWidth: true,
  allowShowDropdown: true,
  wrapperClassname: '',
  dropdownClassName: '',
  dropdownStyle: {},
  positionDropdown: positionDropdown.BOTTOM_START_RIGHT,
  maxDropdownItem: 10,
}
